// Central conversion destinations for AJP cards and future route pages.
// Replace a provider URL here rather than editing every page that uses it.

const NATIONAL_RAIL_URL = "https://www.nationalrail.co.uk/";

const AIRPORT_CONVERSION_LINKS = {
  LHR: {
    parkingUrl: "https://www.heathrow.com/transport-and-directions/heathrow-parking",
    dropoffPath: "/heathrow-dropoff-calculator",
    terminalDropoffPaths: {
      2: "/heathrow-terminal-2-dropoff",
      3: "/heathrow-terminal-3-dropoff",
      4: "/heathrow-terminal-4-dropoff",
      5: "/heathrow-terminal-5-dropoff",
    },
  },
  LGW: {
    parkingUrl: "https://www.gatwickairport.com/parking.html",
    dropoffPath: "/gatwick-dropoff-calculator",
  },
  LTN: {
    parkingUrl: "https://www.london-luton.co.uk/parking",
    dropoffPath: null,
  },
  STN: {
    parkingUrl: "https://www.stanstedairport.com/parking/",
    dropoffPath: "/stansted-dropoff-calculator",
  },
  MAN: {
    parkingUrl: "https://www.manchesterairport.co.uk/parking/",
    dropoffPath: "/manchester-airport/drop-off-calculator",
  },
  EMA: {
    parkingUrl: "https://www.eastmidlandsairport.com/parking/",
    dropoffPath: "/east-midlands-airport/drop-off-calculator",
  },
};

const terminalNumber = (terminal) => {
  const match = String(terminal || "").trim().match(/^(?:terminal\s*|t)?([2-5])\b/i);
  return match ? match[1] : null;
};

export function getAjpConversionLinks(airportCode, terminal) {
  const airport = AIRPORT_CONVERSION_LINKS[String(airportCode || "").toUpperCase()] || {};
  const terminalKey = terminalNumber(terminal);

  return {
    railUrl: NATIONAL_RAIL_URL,
    parkingUrl: airport.parkingUrl || null,
    dropoffPath:
      (terminalKey && airport.terminalDropoffPaths?.[terminalKey]) ||
      airport.dropoffPath ||
      null,
    taxiCallHref: "tel:+441628665040",
  };
}

export const AJP_MODE_STYLES = {
  train: { background: "#f0fdf4", border: "#bbf7d0", accent: "#15803d" },
  taxi: { background: "#fffbeb", border: "#fde68a", accent: "#075bea" },
  self_drive: { background: "#eff6ff", border: "#bfdbfe", accent: "#1d4ed8" },
};
